import { z as zod } from 'zod'

import { DefaultSchemas } from './defaultSchemas'

export const Report13DataSchemas = zod.object({
    transactionId: zod.number(),
    transactionType: zod.string(),
    transactionDate: zod.string(),
    processedDate: zod.string(),
    fromTraderName: zod.string(),
    deviceCode: zod.number().nullable(),
    toTraderName: zod.string(),
    ident: zod.string().nullable(),
    refundedTransactionId: zod.number().nullable(),
    refundTransactionId: zod.number().nullable(),
    traceNumber: zod.number().nullable(),
    purchaseValue: zod.number(),
    loyaltyValue: zod.number(),
    creditValue: zod.number(),
    voucherValue: zod.number(),
    campaignName: zod.string().nullable(),
    comments: zod.string().nullable(),
    ipAddress: zod.string().nullable(),
    login: zod.string().nullable(),
    state: zod.string().nullable(),
    ranking: zod.string().nullable(),
    enrolmentTraderName: zod.string().nullable(),
    custom1: zod.string().nullable(),
    cashier: zod.string().nullable(),
})

export const Report13CSVDataSchemas = zod.object({
    transactionId: zod.number(),
    transactionType: zod.string(),
    transactionDate: zod.string(),
    processedDate: zod.string(),
    fromTraderName: zod.string(),
    deviceCode: zod.number().nullable(),
    toTraderName: zod.string(),
    refundedTransactionId: zod.number().nullable(),
    refundTransactionId: zod.number().nullable(),
    traceNumber: zod.number().nullable(),
    purchaseValue: zod.number(),
    loyaltyValue: zod.number(),
    creditValue: zod.number(),
    comments: zod.string().nullable(),
    login: zod.string().nullable(),
    custom1: zod.string().nullable(),
})

export const Report13ParamsSchemas = zod.object({
})

export const Report13ListTableSchemas = zod.object({
    tableData: Report13DataSchemas.array()
})

export const Report13CreateFormSchemas = zod.object({
    includeAllTrader: zod.number(), // Mandatory: 1 if all traders are to bw shown
    transactionTypeId: zod.number().nullable(),
    startDate: zod.string().min(1, { message: 'Start date is Required.' }),
    endDate: zod.string().min(1, { message: 'End date is Required.' }),
    reportTypeId: zod.string(),
    fromTraderIds: zod.number().array().nullable(),
    merchantTypeId: zod.number().optional().nullable(), //not passing this to API
})

export const Report13APISchemas = DefaultSchemas.merge(zod.object({
    data: Report13DataSchemas.array()
}));

export type Report13CreateFormTypes = zod.infer<typeof Report13CreateFormSchemas>;
export type Report13ListTableTypes = zod.infer<typeof Report13ListTableSchemas>;
export type Report13ParamsTypes = zod.infer<typeof Report13ParamsSchemas>;
export type Report13DataTypes = zod.infer<typeof Report13DataSchemas>;
export type Report13CSVDataTypes = zod.infer<typeof Report13CSVDataSchemas>;
export type Report13APITypes = zod.infer<typeof Report13APISchemas>;